import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../app/api";
import { meKey } from "../../app/me";

/** `POST /api/computer/retry`, then `/api/me` again. */
export function useRetryComputer() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => api("POST", "/api/computer/retry"),
    onSettled: () => client.invalidateQueries({ queryKey: meKey }),
  });
}
